import { useState } from "react";
import CirrusNetworkShareCard from "../../components/CirrusNetworkShareCard";
import CirrusNetworkTrends from "../../components/CirrusNetworkTrends";

export function CirrusNetworkPage() {
  const [view, setView] = useState("current");

  return (
    <div className="mt-12 mb-8 ml-3">
      <div className="mb-4 inline-flex overflow-hidden rounded-lg border border-blue-gray-100">
        {[
          { key: "current", label: "Current" },
          { key: "trends", label: "Trends" },
        ].map((v) => (
          <button
            key={v.key}
            onClick={() => setView(v.key)}
            className={`px-4 py-1.5 text-sm font-medium transition-colors ${
              view === v.key
                ? "bg-blue-gray-800 text-white"
                : "bg-white text-blue-gray-600 hover:bg-blue-gray-50"
            }`}
          >
            {v.label}
          </button>
        ))}
      </div>
      {view === "current" ? <CirrusNetworkShareCard /> : <CirrusNetworkTrends />}
    </div>
  );
}

export default CirrusNetworkPage;
